import KeyValueCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';

export const getDefaultState = () => new KeyValueCollection([
    {
        key: '5',
        value: 'Available for Analysis'
    },
    {
        key: '0',
        value: 'In-Process'
    },
    {
        key: '4',
        value: 'Sent to Supplier'
    },
    {
        key: '3',
        value: 'Supplier Analysis Completed'
    },
    {
        key: '2',
        value: 'Analysis Complete'
    },
    {
        key: '1',
        value: 'Closed'
    }
]);



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/state/rga-analysis-status.js